import { PublicRoute as PublicRouteView } from './PublicRoute.view';
export * from './PublicRoute.view';

export const PublicRoute = (props) => PublicRouteView(props);

export default PublicRoute;

